/*
 * Os ícones das abas e do rodapé do menu do usuário, desenhados com o
 * Lucide — traço de 2px, pontas redondas —, que o Font Awesome
 * do Flarum não tem com o mesmo traço. A classe base `.CanelaIcon` (da casca,
 * Header.less) dá o traço; o tamanho vem do UserMenu.less.
 */

import { lucideChildren } from '../icons';
function svg(name, children) {
  return m("svg", {
    className: `CanelaIcon CanelaIcon--${name}`,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false"
  }, children);
}

// Nome da aba → desenho do Lucide (icons/glyphs.ts).
const PATHS = {
  bell: 'bell',
  reply: 'reply',
  heart: 'heart',
  mail: 'mail',
  bookmark: 'bookmark',
  // O balão do chat.
  chat: 'message-square-text',
  // A aba "outras": uma grade 2×2.
  other: 'grid-2x2',
  flag: 'flag',
  user: 'user',
  chevronDown: 'chevron-down',
  check: 'check'
};
export function menuIcon(name) {
  const paths = PATHS[name];
  return paths ? svg(name, lucideChildren(paths)) : null;
}
flarum.reg.add('ramon-canela', 'forum/usermenu/icons', { menuIcon: menuIcon, });